import { combineReducers } from 'redux';

import menu from './menu/reducer';
import chatApp from './chat/reducer';
import dom from './dom/reducer';
import alerts from './alerts/reducer';
import ui from './ui/reducer';
import forms from './forms/reducer';
import session from './session/reducer';
import dashboard from './dashboard/reducer';
import settings from './settings/reducer';

const reducers = combineReducers({
  menu,
  chatApp,
  dom,
  alerts,
  forms,
  session,
  dashboard,
  settings,
  ui

});

export default reducers;
